export default __webpack_public_path__ + "vertical-resizing-option.png";